
import update from 'immutability-helper';
import { setStepNumberState } from 'actions/livefeed/historyActions'

export const GO_TO_SLIDE = 'GO_TO_SLIDE'
export function goToSlide(index) {
    return {
        type: GO_TO_SLIDE,
        index
    }
}

export const ADD_SLIDE = 'ADD_SLIDE'
export function addSlide(objectSlide) {
    return {
        type: ADD_SLIDE,
        objectSlide
    }
}

export const ADD_SUM_SLIDE = 'ADD_SUM_SLIDE'
export function addSumSlide(objectSlide) {
    return {
        type: ADD_SUM_SLIDE,
        objectSlide
    }
}

export const REMOVE_SLIDE = 'REMOVE_SLIDE'
export function removeSlide(slideIndex) {
    return {
        type: REMOVE_SLIDE,
        slideIndex
    }
}

export const SORT_SLIDE_ORDER = 'SORT_SLIDE_ORDER'
export function sortSlide(newOrder) {
    return {
        type: SORT_SLIDE_ORDER,
        newOrder
    }
}

// ------------------------------------slide function

export function setNewSlideOrder(payload) {
    return (dispatch) => {
        let emptyHistory = [{ id: null, fontFamily: payload[0].fontFamily }]// get fontFamily of summary slide
        let newArrWithEmptyHistory = payload
        for (let i = 0; i < payload.length; i++) {
            newArrWithEmptyHistory = update(newArrWithEmptyHistory,
                {
                    [i]: {
                        historyEntities: {
                            $set: emptyHistory
                        }
                    }
                })
        }
        dispatch(setStepNumberState(0))
        dispatch(sortSlide(newArrWithEmptyHistory))
    }
}


// WEBPACK FOOTER //
// ./src/actions/livefeed/slideCrudActions.js